"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _View = _interopRequireDefault(require("../ui/View"));

var _Switch = _interopRequireDefault(require("../ui/Switch"));

var _Indices = require("../data/Indices");

var _utils = require("../../utils");

var _strings = require("../../utils/strings");

var _units = require("../../utils/units");

var _utils2 = require("../../maps/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var cachedInfoPanelViews = {
  units: {
    id: 'units',
    static: true,
    renderer: function (data) {
      return "\n\t\t\t<div class=\"awxjs__app__ui-panel-info__units\">\n\t\t\t\t<div class=\"awxjs__ui-cols align-center justify-between\">\n\t\t\t\t\t<div class=\"label\">Units</div>\n\t\t\t\t\t<div class=\"control\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
    },
    init: function (view, contentView) {
      var control = new _Switch.default({
        values: [{
          label: 'Imperial',
          value: "imperial"
          /* Imperial */

        }, {
          label: 'Metric',
          value: "metric"
          /* Metric */

        }]
      });

      var update = function () {
        if (contentView.units === "metric"
        /* Metric */
        ) {
            control.select();
          } else {
          control.deselect();
        }
      };

      contentView.on('change:units', function (e) {
        update();
      });
      update();
      control.addTo(view.el('.control'));
      control.on('select', function () {
        contentView.units = "metric"
        /* Metric */
        ;
      }).on('deselect', function () {
        contentView.units = "imperial"
        /* Imperial */
        ;
      });
    }
  },
  place: {
    id: 'place',
    requiresData: true,
    request: function (account, data) {
      return account.api().endpoint('places');
    },
    data: function (data) {
      if ((0, _utils.isEmpty)(data)) return null;
      data = data.places || data;
      return data.place;
    },
    renderer: function (data) {
      return "\n\t\t\t<div class=\"awxjs__app__ui-panel-info__place\">\n\t\t\t\t<div class=\"awxjs__app__ui-panel-info__place-name\">" + data.name + (!(0, _utils.isEmpty)(data.state) ? ", " + data.state : '') + ", " + data.country + "</div>\n\t\t\t</div>\n\t\t";
    }
  },
  obs: {
    id: 'observations',
    requiresData: true,
    request: function (account, data) {
      return account.api().endpoint('conditions');
    },
    data: function (data) {
      if ((0, _utils.isEmpty)(data)) return null;
      data = data.observations || data;
      return data.ob;
    },
    renderer: function (data) {
      var date = (0, _utils.dateFromISO)(data.dateTimeISO);
      var metric = data.units === "metric"
      /* Metric */
      ;
      return "\n\t\t\t\t<div class=\"awxjs__app__ui-panel-info__obs\">\n\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__obs-timestamp\">Last updated at " + (0, _utils.formatDate)(date, metric ? 'HH:mm, MMM d, yyyy' : 'h:mm a, MMM dd, yyyy') + "</div>\n\t\t\t\t\t<div class=\"awxjs__ui-cols\">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-cols\">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__obs-temp\">" + ((0, _units.formatDataValue)(data, 'tempF', 'tempC', metric) || 'N/A') + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<img class=\"awxjs__app__ui-panel-info__obs-icon\" src=\"https://cdn.aerisapi.com/wxblox/icons/" + (data.icon || 'na.png') + "\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__obs-wx\">" + data.weatherPrimary + "</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__obs-details\">\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Winds</div>\n\t\t\t\t\t\t\t\t<div>" + (data.windSpeedMPH > 0 ? "" + (0, _units.formatDataValue)(data, 'windSpeedMPH', 'windSpeedKPH', metric) : "Calm") + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Dew Point</div>\n\t\t\t\t\t\t\t\t<div>" + (0, _units.formatDataValue)(data, 'dewpointF', 'dewpointC', metric) + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Humidity</div>\n\t\t\t\t\t\t\t\t<div>" + (0, _units.formatDataValue)(data, 'humidity') + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Pressure</div>\n\t\t\t\t\t\t\t\t<div>" + (0, _units.formatDataValue)(data, 'pressureIN', 'pressureMB', metric) + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Visibility</div>\n\t\t\t\t\t\t\t\t<div>" + (0, _units.formatDataValue)(data, 'visibilityMI', 'visibilityKM', metric) + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-row\">\n\t\t\t\t\t\t\t\t<div>Sky Cover</div>\n\t\t\t\t\t\t\t\t<div>" + (0, _units.formatDataValue)(data, 'sky') + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t";
    }
  },
  forecast: {
    id: 'forecast',
    requiresData: true,
    request: function (account, data) {
      var forecastFields = "\n\t\t\t\t\ttimestamp,dateTimeISO,tempF,tempC,icon,weatherPrimary,windSpeedMPH,windSpeedKPH,windSpeedMinMPH,windSpeedMinKPH,\n\t\t\t\t\twindSpeedMaxMPH,windSpeedMaxKPH,windGustMPH,windGustKPH,snowIN,snowCM,precipIN,precipMM\n\t\t\t\t".split(',').map(function (key) {
        return "periods." + key;
      });
      return account.api().endpoint('forecasts').fields(forecastFields.join(',')).filter('3hr').limit(7);
    },
    data: function (data) {
      if ((0, _utils.isEmpty)(data)) return null;
      data = data.forecasts || data;

      if (data) {
        if (data[0]) data = data[0];
        data = data.periods;
      }

      return {
        periods: data || []
      };
    },
    renderer: function (data) {
      var metric = data.units === "metric"
      /* Metric */
      ;
      return data.periods.map(function (period) {
        var date = (0, _utils.dateFromISO)(period.dateTimeISO);
        var winds = 'Calm';

        if (period.windSpeedMaxMPH > 5) {
          if (metric) {
            winds = (0, _utils.toRangeStr)(period.windSpeedMinKPH, period.windSpeedMaxKPH, 5) + " " + (0, _units.unitsForDataType)('speed', true);
          } else {
            winds = (0, _utils.toRangeStr)(period.windSpeedMinMPH, period.windSpeedMaxMPH, 5) + " " + (0, _units.unitsForDataType)('speed', false);
          }
        } else if (period.windSpeedMaxMPH < 5 && period.windSpeedMinMPH > 0) {
          winds = metric ? '< 8 kmh' : '< 5 mph';
        }

        return "\n\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast\">\n\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-period\">\n\t\t\t\t\t\t\t<div class=\"awxjs__ui-cols align-center\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-ts\">" + (0, _utils.formatDate)(date, metric ? 'HH:00' : 'h a') + "</div>\n\t\t\t\t\t\t\t\t<div><img class=\"awxjs__app__ui-panel-info__forecast-icon\" src=\"https://cdn.aerisapi.com/wxblox/icons/" + (period.icon || 'na.png') + "\"></div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-temp\">" + (0, _units.formatDataValue)(period, 'tempF', 'tempC', metric) + "</div>\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-conditions\">\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-wx\">" + period.weatherPrimary + "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__forecast-detail\"><span>Winds</span> " + winds + "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t";
      }).join('');
    }
  },
  alerts: {
    id: 'alerts',
    requiresData: true,
    request: function (account, data) {
      return account.api().endpoint('alerts').fields('details.type,details.name,timestamps');
    },
    data: function (data) {
      if ((0, _utils.isEmpty)(data)) return null; // add parent places.profile to each alert so we can do proper timezone conversions

      var profile = (0, _utils.get)(data, 'places.profile');
      if (data.alerts) data = data.alerts;

      if ((0, _utils.isArray)(data)) {
        return data.map(function (record) {
          return (0, _utils.extend)(record, {
            profile: profile
          });
        });
      }

      return null;
    },
    renderer: function (data) {
      var metric = data.units === "metric"
      /* Metric */
      ;
      var alerts = data.map(function (alert) {
        var range = '';
        var ts = alert.timestamps;

        if (ts) {
          var offset = (0, _utils.get)(alert, 'profile.tzoffset') ? (0, _utils.get)(alert, 'profile.tzoffset') * 1000 : 0;
          var utcOffset = new Date().getTimezoneOffset() * 60000;
          var tzShift = utcOffset + offset;
          var tz = (0, _utils.get)(alert, 'profile.tzname') || ''; // need to add timezone offset difference between the local and alert timezones

          var now = new Date(new Date().getTime() + tzShift);
          var start = new Date(new Date(ts.begins * 1000).getTime() + tzShift);
          var end = new Date(new Date(ts.expires * 1000).getTime() + tzShift);
          var fmt = metric ? "HH:00 [" + tz + "], ddd M/d" : "h:mm a '" + tz + "', EEE M/d";

          if (start.getTime() < now.getTime()) {
            range = " until " + (0, _utils.formatDate)(end, fmt);
          } else {
            range = " from " + (0, _utils.formatDate)(start, fmt) + " until " + (0, _utils.formatDate)(end, fmt);
          }
        }

        return "\n\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__alert\">\n\t\t\t\t\t\t<span class=\"awxjs__app__ui-panel-info__alert-name\"><strong>" + (0, _strings.ucwords)(alert.details.name.toLowerCase()) + "</strong></span>\n\t\t\t\t\t<br>" + range + "</div>\n\t\t\t\t";
      }).join('');
      return "<div class=\"awxjs__app__ui-panel-info__alerts\">" + alerts + "</div>";
    }
  },
  threats: {
    id: 'threats',
    requiresData: true,
    request: function (account, data) {
      return account.api().endpoint('threats').radius('50mi');
    },
    data: function (data) {
      return (0, _utils.get)(data, 'threats.0.periods.0.storms');
    },
    renderer: function (data) {
      return (0, _utils2.renderWithFallback)(function (threat) {
        return "<div class=\"awxjs__app__ui-panel-info__threats\"><div class=\"awxjs__app__ui-panel-info__threats-row\">" + (0, _strings.formatDirections)(threat.phrase.long) + "</div></div>\n\t\t";
      }, data);
    }
  },
  outlook: {
    id: 'outlook',
    requiresData: true,
    request: function (account, data) {
      return account.api().endpoint('phrases/summary');
    },
    data: function (data) {
      return (0, _utils.get)(data, 'phrases_summary.0');
    },
    renderer: function (data) {
      return (0, _utils2.renderWithFallback)(function (outlook) {
        var metric = outlook.units === "metric"
        /* Metric */
        ;
        return "<div class=\"awxjs__app__ui-panel-info__outlook\">" + (metric ? (0, _utils.get)(outlook, 'phrases.longMET') : (0, _utils.get)(outlook, 'phrases.long')) + "</div>";
      }, data);
    }
  },
  hazards: {
    id: 'hazards',
    requiresData: true,
    request: function (account, data) {
      if (!(0, _utils.isset)(data.p)) {
        return undefined;
      }

      var request = account.api();
      var forecastFields = "\n\t\t\t\t\ttimestamp,dateTimeISO,tempF,tempC,icon,weatherPrimary,windSpeedMPH,windSpeedKPH,windSpeedMinMPH,windSpeedMinKPH,\n\t\t\t\t\twindSpeedMaxMPH,windSpeedMaxKPH,windGustMPH,windGustKPH,snowIN,snowCM,precipIN,precipMM\n\t\t\t\t".split(',').map(function (key) {
        return "periods." + key;
      });
      request.addRequest(account.api().endpoint('forecasts').fields(forecastFields.join(',')).filter('3hr').limit(7));
      request.addRequest(account.api().endpoint('observations'));
      request.addRequest(account.api().endpoint('convective/outlook').action("contains"
      /* CONTAINS */
      ));
      request.addRequest(account.api().endpoint('lightning/summary').action("closest"
      /* CLOSEST */
      ).radius('60mi').limit(100));
      return request;
    },
    data: function (data) {
      if ((0, _utils.isEmpty)(data)) {
        return undefined;
      }

      var ob = (0, _utils.get)(data, 'observations.ob') || {};
      var forecasts = (0, _utils.get)(data, 'forecasts');
      var convective = (0, _utils.get)(data, 'convective_outlook_contains');
      var lightning = (0, _utils.get)(data, 'lightning_summary_closest');

      if ((0, _utils.isEmpty)(ob) && (0, _utils.isEmpty)(forecasts)) {
        return undefined;
      }

      var result = [];

      if (forecasts && forecasts.length > 0) {
        var periods = forecasts[0].periods;
        var snow_1 = 0;
        var rain_1 = 0;
        var wind_1 = 0;
        var ice_1 = 0;

        if (ob) {
          if (ob.tempF <= 30 && /snow/.test(ob.weatherPrimary) === false) {
            ice_1 += ob.precipIN;
          }
        }

        periods.forEach(function (period) {
          snow_1 += period.snowIN;
          wind_1 = Math.max(wind_1, period.windGustMPH);

          if (period.tempF >= 30) {
            rain_1 += period.precipIN;
          }

          if (period.tempF >= 28 && period.tempF <= 32) {
            ice_1 += period.precipIN;
          }
        });
        result.push({
          type: 'snow',
          name: 'Snow',
          value: snow_1
        });
        result.push({
          type: 'ice',
          name: 'Ice',
          value: ice_1
        });
        result.push({
          type: 'rain',
          name: 'Rain',
          value: rain_1
        });
        result.push({
          type: 'wind',
          name: 'Wind',
          value: wind_1
        });
      }

      if (convective && convective.length > 0) {
        var risk = convective[0].details.risk;
        result.push({
          type: 'convective',
          name: 'Convective',
          value: risk.type
        });
      } else {
        result.push({
          type: 'convective',
          name: 'Convective',
          value: 'none'
        });
      }

      if (lightning) {
        var count = (0, _utils.get)(lightning[0] || lightning, 'summary.pulse.count');
        result.push({
          type: 'lightning',
          name: 'Lightning',
          value: count
        });
      } else {
        result.push({
          type: 'lightning',
          name: 'Lightning',
          value: 0
        });
      }

      return result;
    },
    renderer: function (data) {
      var hazards = data.map(function (hazard) {
        var index = (0, _Indices.valueForIndice)(hazard.type, hazard.value) || 0;
        var percent = Math.round(index / 5 * 1000) / 10;
        var indexStr = ("" + index).replace(/\./g, 'p'); // determine impact level based on percentage

        var level = 'None';
        if (percent >= 80) level = 'Major';else if (percent >= 60) level = 'High';else if (percent >= 40) level = 'Moderate';else if (percent >= 20) level = 'Low';else if (percent > 0) level = 'Minimal';
        return "\n\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard awxjs__ui-cols align-center\">\n\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard-label\">" + hazard.name + "</div>\n\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard-bar\">\n\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard-bar-inner\">\n\t\t\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard-bar-progress awxjs__app__ui-panel-info__hazard-indice-fill-" + indexStr + "\" style=\"width:" + percent + "%;\"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"awxjs__app__ui-panel-info__hazard-value awxjs__app__ui-panel-info__hazard-value-" + indexStr + "\">" + level + "</div>\n\t\t\t\t\t</div>\n\t\t\t\t";
      });
      return "<div class=\"awxjs__app__ui-panel-info__hazards\">" + hazards.join('') + "</div>";
    }
  }
};
/**
 * An `InfoPanelView` is a view component that renders content associated with a single dataset or
 * content type within an info panel's content view.
 *
 * @export
 * @class InfoPanelView
 * @extends {View<InfoPanelViewOptions>}
 */

var InfoPanelView =
/** @class */
function (_super) {
  __extends(InfoPanelView, _super);
  /**
   * Initializes and returns an info panel view instance configured with the specified
   * configuration options and optional data.
   *
   * @param {InfoPanelViewOptions} [opts]
   * @param {*} [data]
   * @memberof InfoPanelView
   */


  function InfoPanelView(opts, data) {
    var _this = this;

    opts = (0, _utils.extend)({}, opts, {
      className: opts.className ? "app__ui-panel-info__view " + opts.className : 'app__ui-panel-info__view'
    });

    if ((0, _utils.isString)(opts.renderer)) {
      var section = InfoPanelView.getSection(opts.renderer);

      if (section) {
        opts = (0, _utils.extend)({}, section, opts, {
          renderer: section.renderer
        });
      }
    }

    _this = _super.call(this, opts, data) || this;
    return _this;
  }

  Object.defineProperty(InfoPanelView.prototype, "static", {
    get: function () {
      return this.opts.static;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InfoPanelView.prototype, "request", {
    get: function () {
      return this.opts.request;
    },
    enumerable: false,
    configurable: true
  });

  InfoPanelView.prototype.addToContentView = function (view, index) {
    if (index === void 0) {
      index = -1;
    }

    var initializer = this.opts.init;
    this.addTo(view.$el, false, index);

    if (initializer && (0, _utils.isFunction)(initializer)) {
      initializer(this, view);
    }
  };
  /** Class Methods */

  /**
   * Adds a view to the cache using the specified key identifier.
   *
   * @static
   * @param {string} key
   * @param {InfoPanelSectionView} section
   * @memberof InfoPanelView
   */


  InfoPanelView.setSection = function (key, section) {
    cachedInfoPanelViews[key] = section;
  };
  /**
   * Returns the cached view associated with the key identifier, if any.
   *
   * @static
   * @param {string} key
   * @returns {InfoPanelSectionView}
   * @memberof InfoPanelView
   */


  InfoPanelView.getSection = function (key) {
    return cachedInfoPanelViews[key];
  };

  InfoPanelView.prototype._render = function (data) {
    var content = '';
    var renderer = this.opts.renderer;

    if (this.opts.requiresData && (0, _utils.isEmpty)(data)) {
      renderer = null;
    }

    if (renderer) {
      // update renderer to account for title and passing renderers to render function
      var sections = Object.keys(cachedInfoPanelViews).reduce(function (previous, key) {
        previous[key] = cachedInfoPanelViews[key].renderer;
        return previous;
      }, {}); // if (this.opts.requiresData && isEmpty(data)) {
      // 	return '';
      // }

      var title = this.opts.title ? "<div class=\"awxjs__app__ui-panel-info__view-title\">" + this.opts.title + "</div>" : '';

      if ((0, _utils.isFunction)(renderer)) {
        var renderFn = renderer;
        content = "\n\t\t\t\t\t" + title + "\n\t\t\t\t\t" + renderFn(data || {}, sections) + "\n\t\t\t\t";
      } else if ((0, _utils.isString)(renderer)) {
        content = "\n\t\t\t\t\t" + title + "\n\t\t\t\t\t" + renderer + "\n\t\t\t\t";
      }
    }

    return "\n\t\t\t<div class=\"awxjs__app__ui-panel-info__view\">" + content + "</div>\n\t\t";
  };
  /**
   * Built-in views keyed by unique type identifiers.
   *
   * @static
   * @memberof InfoPanelView
   */


  InfoPanelView.cached = cachedInfoPanelViews;
  return InfoPanelView;
}(_View.default);

var _default = InfoPanelView;
exports.default = _default;
module.exports = exports.default;